import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { getIntervalTime } from 'webapp/utils/number';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	onClose: () => void;
}

export default class AppNotificationsTrialComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;
	@service('account') declare accountService: Service.Account;
	@service('ai-chat') declare aiChatService: Service.AIChat;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	get timeLeft() {
		return getIntervalTime(this.billingService.activeTimeLeft, 'second', true);
	}

	@action
	contactSupport() {
		this.currentUserService.chatWithSupport();
	}
	<template>
		<div class="notification-container trial-notification">
			<div class="container">
				<a role="button" class="close" {{on "click" @onClose}}>
					<CommonUiIconComponent @name="Close" @size="sm" />
				</a>

				<p>
					You have
					<strong>{{this.timeLeft}} remaining</strong>
					on your free trial of
					<strong>{{this.billingService.activePlan.name}}</strong>
				</p>
				<LinkTo class="button size-small" @route="settings.billing">Buy now</LinkTo>
				{{#if this.aiChatService.hasSupportChat}}
					<a class="link-blue" role="button" {{on "click" this.contactSupport}}>
						Contact support
					</a>
				{{/if}}
			</div>
		</div>
	</template>
}
